import Vue from 'vue'
import Vuex from 'vuex'

import usuario from './modules/usuario'
import sideBar from './modules/sideBar'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    usuario,
    sideBar
  }
})
